import styled from 'styled-components';
import { List } from 'antd';

const { Item } = List;

export default styled(Item)`
  padding: 8px 12px;
  display: block;
`;
